import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash"
import {LocationType} from "../../../commons/types/location.type";
import {FulfillmentStatusType} from "../../types/fulfillment-status.type";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";

export class FulfillmentLineComponent implements IController {

  fulfillment: any;
  fulfillmentLine: any;
  relations?: any[];
  fulfillmentLineIndex: number;
  steps: any[] = [];
  settings: any;
  packageList: any;
  metadata?: any[];
  weightUnit: any;
  volumeUnit: any;
  distanceUnit: any;
  viewedStepsIds: any;
  selectedKeys: any;
  excludeMode: boolean;
  isShowCheckboxes: boolean;
  isShowLineCheckbox: boolean;
  selectedLineIdMap: any;
  fulfillmentLineStepsPriceInfo: any;
  onDispatch: Function;
  onSplit: Function;
  onAutoAssign: Function;
  onCancelService: Function;
  onCancelAttempt: Function
  onCancelLine: Function;
  onAssignAgent: Function;
  onToggleViewStep: Function;
  onToggleSelect: Function;
  onLineSelectedChange: Function;
  onAssignRoute: Function;
  onReset: Function;
  onAddNote: Function;
  onAssignResourceAllocation: Function;
  onCreateRoute: Function;
  onCompleteManually: Function;
  onCreateReturnDelivery: Function;
  onSplitPackage: Function;
  onDispatchExternal: Function;
  onCancelStep: Function;
  onForceCompleteLine: Function;

  public fulfillmentLineStepIds: string[];
  public fulfillmentLineSteps: any[];
  public viewedStepsIdsMap: any = {};
  public fulfillmentFilteredStepsMap: any = {};
  public locationTypes: typeof LocationType = LocationType;
  public canCopyPickupDepot: boolean;
  public canCopyDestinationDepot: boolean;
  public canCopyPickupCustomer: boolean;
  public canCopyDestinationCustomer: boolean;
  public fulfillmentStatuses: typeof FulfillmentStatusType = FulfillmentStatusType;
  public fulfillmentLineStepsPriceInfoMap: any = {};
  public relationsMap: any;

  constructor(private fulfillmentDialogService: FulfillmentDialogService) {
  }

  $onInit() {
    this._setFulfillmentLineStepData();
    this._setFulfillmentFilteredStepsMap();
    _.forEach(this.viewedStepsIds, (selectedId) => {
      this.viewedStepsIdsMap[selectedId] = true;
    });
    if (this.fulfillmentLineStepsPriceInfo?.steps) {
      this._mapFulfillmentLineStepsPriceInfo();
    }

  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (
      changes.fulfillment && !changes.fulfillment.isFirstChange() ||
      changes.fulfillmentLine && !changes.fulfillmentLine.isFirstChange()
    ) {
      this._setFulfillmentLineStepData();
      this._setFulfillmentFilteredStepsMap();
    }
    if (changes.viewedStepsIds && !changes.viewedStepsIds.isFirstChange()) {
      this.viewedStepsIdsMap = {}
      _.forEach(this.viewedStepsIds, (selectedId) => {
        this.viewedStepsIdsMap[selectedId] = true;
      });
    }
    if (changes.fulfillmentLineStepsPriceInfo && !changes.fulfillmentLineStepsPriceInfo.isFirstChange()) {
      this._mapFulfillmentLineStepsPriceInfo();
    }
    if (changes.relations) {
      this.relationsMap = {};
      this.relations?.forEach((r) => {
        r.sourceIds?.forEach((sourceId) => {
          if (_.includes(this.fulfillmentLineStepIds, sourceId)) {
            if (!this.relationsMap[sourceId]) {
              this.relationsMap[sourceId] = [];
            }
            this.relationsMap[sourceId].push(r);
          }
        })
        r.targetIds?.forEach((targetId) => {
          if (_.includes(this.fulfillmentLineStepIds, targetId)) {
            if (!this.relationsMap[targetId]) {
              this.relationsMap[targetId] = [];
            }
            this.relationsMap[targetId].push(r);
          }
        })
      })

    }
  }

  onViewPods(fulfillmentSteps,event){
    this.fulfillmentDialogService.identificationsImages(fulfillmentSteps,'Manage Leg PODs');
  }

  private _setFulfillmentLineStepData() {

    if (!this.fulfillment || !this.fulfillmentLine) {
      this.fulfillmentLineStepIds = [];
      return;
    }

    // this.fulfillmentLineStepIds = _.chain(this.fulfillment.fulfillmentSteps)
    //   .filter((step) => {
    //     return step.fulfillmentLineId === this.fulfillmentLine.id
    //   })
    //   .map((filteredStep) => {
    //     return filteredStep.id
    //   })
    //   .value();

    this.fulfillmentLineSteps = angular.copy(_.filter(this.fulfillment.fulfillmentSteps, (s) => {
      return s.fulfillmentLineId === this.fulfillmentLine.id && s.status !== 'Splitted';
    }));

    this.fulfillmentLineStepIds = _.map(this.fulfillmentLineSteps, 'id');
  }

  private _setFulfillmentFilteredStepsMap() {
    _.forEach(this.fulfillment.fulfillmentSteps, step => {
      this.fulfillmentFilteredStepsMap[step.id] = step.matchFilter
    })
  }

  private _mapFulfillmentLineStepsPriceInfo() {
    _.forEach(this.fulfillmentLineStepsPriceInfo.steps, step => {
      if (!this.fulfillmentLineStepsPriceInfoMap[step.stepId]) {
        this.fulfillmentLineStepsPriceInfoMap[step.stepId] = {};
      }
      this.fulfillmentLineStepsPriceInfoMap[step.stepId] = step;
      this.fulfillmentLineStepsPriceInfoMap[step.stepId].linePrice = this.fulfillmentLineStepsPriceInfo.linePrice
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLine', {
    bindings: {
      fulfillment: '<',
      fulfillmentLine: '<',
      relations: '<?',
      steps: '<',
      settings: '<',
      weightUnit: '<',
      volumeUnit: '<',
      distanceUnit: '<',
      packageList: '<',
      metadata: '<',
      viewedStepsIds: '<',
      selectedKeys: '<',
      excludeMode: '<',
      fulfillmentLineIndex: '<',
      isShowCheckboxes: '<',
      isShowLineCheckbox: '<?',
      selectedLineIdMap: '<?',
      fulfillmentLineStepsPriceInfo: '<',
      onToggleSelect: '&',
      onLineSelectedChange: '&',
      onToggleViewStep: '&',
      onDispatch: '&',
      onSplit: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onAssignRoute: '&',
      onAssignResourceAllocation: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onCancelLine: '&',
      onAddNote: '&',
      onCreateRoute: '&',
      onCompleteManually: '&',
      onCreateReturnDelivery: '&',
      onReset: '&',
      onSplitPackage: '&',
      onDispatchExternal: '&',
      onCancelStep: '&',
      onForceCompleteLine: '&'
    },
    template: require('./fulfillment-line.html').default,
    controller: FulfillmentLineComponent
  });
